<template>
  <div>
    <!-- 상단 고정 캠페인 배너 -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>

    <div class="bg-white pda-default full-height">
      <div class="t-body3 t-color-content1 pdb-16">
        <div>{{ $t("S20024") }}</div>
        <div>{{ $t("S20025") }}</div>
      </div>
      <div class="t-body3 t-color-content1 pdb-16">
        <div>{{ $t("S20026") }}</div>
        <div>
          {{ $t("S20027") }}
        </div>
        <div>{{ $t("S20028") }}</div>
      </div>

      <div class="t-body3 t-color-content1 pdb-16">
        <div>{{ $t("S20029") }}</div>
        <div>
          {{ $t("S20030") }}
        </div>
        <div>
          {{ $t("S20031") }}
        </div>
      </div>

      <div class="t-body3 t-color-content1 pdb-16">
        <div>{{ $t("S20032") }}</div>
        <div>{{ $t("S20033") }}</div>
        <div>
          {{ $t("S20034") }}
        </div>
      </div>

      <div class="t-body3 t-color-content1 pdb-16">
        <div>
          {{ $t("S20035") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import prizeRequestApi from "@/api/prizeRequestApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoData.vue";

export default {
  components: {
    ListItem,
    NoData,
    TopAppBar,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      infiniteId: +new Date(),
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      showModalCss: false,

      checkBox: false,
      params: {
        name: null,
        passportNumber: null,
        cellphone: null,
        email: null,
        address: null,
        quantity: null,
        totalPrice: null,
      },
      itemDetails: null,
      prize_id: null,
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarCloseOnly(this.$t("S20004"));
    this.prize_id = this.$route.params.prizeid;
    this.qty = this.$route.params.qty;
    this.fetchData();
  },

  methods: {
    setMaterialUi() {
      this.name_ref1 = new MDCTextField(document.querySelector("#name_ref"));
      this.passport_ref1 = new MDCTextField(
        document.querySelector("#passport_ref")
      );
      this.phone_ref1 = new MDCTextField(document.querySelector("#phone_ref"));
      this.email_ref1 = new MDCTextField(document.querySelector("#email_ref"));
      this.address_ref1 = new MDCTextField(
        document.querySelector("#address_ref")
      );
    },

    // 목록 데이터 로딩(get list data)
    fetchData() {
      let responseData = null;
      prizeRequestApi
        .prizeProductDetails(this.prize_id)
        .then((response) => {
          this.itemDetails = response.data.data;
          this.setMaterialUi();
        })
        .catch((err) => {});
    },
    submitForm() {
      this.params.quantity = this.qty;
      this.params.totalPrice = this.itemDetails.price;
      console.log("final data", this.params);
      prizeRequestApi
        .prizePurchaseRequest(this.prize_id, this.params)
        .then((response) => {
          // console.log("responseresponse", response.data.data.id);
          this.$router.push({
            name: "PurchaseCompleted",
            params: { prizeid: response.data.data.id },
          });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.tabs .tab {
  width: 50%;
}
.mgb-100 {
  margin-bottom: 100px !important;
}
.footer-tag {
  box-shadow: 1px -4px 12px 0 rgba(0, 0, 0, 0.2);
  bottom: 0;
  z-index: 9999;
}
.bg-blue1 {
  background: #2d6dcc !important;
}

.placeholderImageDetails img {
  object-fit: cover;
  object-position: left;
}
.myInfoForm .select-wrapper input.select-dropdown {
  border: solid 1px rgba(172, 180, 190, 0.7);
  padding-left: 14px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #a6a6a6;
  font-size: 14px;
}
.myInfoForm .select-wrapper .caret {
  right: 12px;
  fill: #a6a6a6;
}
.dropdown-content li > a,
.dropdown-content li > span {
  font-size: 14px;
  color: #818181;
  display: block;
  line-height: 22px;
  padding: 14px 16px;
}
.myInfoForm .customInput {
  border: solid 1px rgba(172, 180, 190, 0.7) !important;
  padding-left: 16px !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
  color: #212121 !important;
  box-shadow: none !important;
  font-size: 14px !important;
}
.myInfoForm .customInput:focus {
  border-color: #546e7a !important;
}
.myInfoForm .customInput:not([value=""]):not(:focus):invalid {
  border: #546e7a !important;
}
.myInfoForm .input-field > label:not(.label-icon).active {
  -webkit-transform: translateY(-14px) scale(0.8);
  transform: translateY(-14px) scale(0.8);
  -webkit-transform-origin: 0 0;
  transform-origin: left;
  background: #fff;
  padding: 0 10px;
  width: auto !important;
  left: 6px;
  top: 2px;
  color: #546e7a !important;
}
.myInfoForm .input-field > label {
  font-size: 14px !important;
}

.custom_check .mdc-checkbox__background {
  left: 0 !important;
}
.custom_check > label {
  margin-left: -4px;
}

.full-height {
  height: 100vh;
}
</style>